.root {
    --dot-width: var(--carousel-dot-width, 12px);
    --dot-color: var(--carousel-dot-color, black);
    --dot-active-color: var(--carousel-dot-active-color, gray);

    display: flex;
    justify-content: center;
}

.dot {
    --touch-target: 24px;
    --padding: calc((var(--touch-target) - var(--dot-width)) / 2);

    position: relative;
    width: var(--dot-width);
    height: var(--dot-width);
    margin: var(--padding);
    border-radius: var(--dot-width);
    padding: 0;
    border-width: 0;
    background-color: var(--dot-color);

    &::before {
        content: "";
        position: absolute;
        inset: calc(-1 * var(--padding));
    }

    &:focus-visible,
    &[data-focus-visible] {
        outline: 1px solid var(--dot-active-color);
        outline-offset: 4px;
    }

    &[data-active] {
        background-color: var(--dot-active-color);
    }
}
